import { random } from "remotion";
import { roundToThousandths } from "../numbers.js";
const HALF_PI = Math.PI / 2;
/**
 * @returns An integer in this cycle: 0, 1, 0, -1
 */
export function getStaggerFactor({ frame, seed, minIntervalFrames, staggerFrames, }) {
    // the number of frames the coordinates will remain static for
    // A random interval between minIntervalFrames and `minIntervalFrames +
    // staggerFrames`
    const intervalFrames = Math.floor(minIntervalFrames + random(seed) * staggerFrames);
    const currentInterval = Math.floor(frame / intervalFrames);
    // Use a sine wave so the scaling back and forth is cyclical. Multiplying the
    // interval by PI/2 makes the sine wave complete a full cycle every 2
    // intervals
    const factor = Math.sin(currentInterval * HALF_PI);
    // make sure it's an integer value and not off by some tiny amount around zero
    // (i.e. should return 0, 1, 0, -1)
    const result = roundToThousandths(factor);
    return result === -0 ? 0 : result;
}
